import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { Util } from '../common/common.util';

export interface ExtPersonalScorecardListItem {
    userId: number;
    scoreCardId: number;
    periodTypeId: number;
    scoreCardName: string;
    startDate: string;
    endDate: string;
    score: string;
    myRank: number;
    maxRank: number;
    sgRank: string;
}

export interface PersonalScorecardListItem {
    id: number;
    name: string;
    startDate: Date;
    endDate: Date;
    score: number;
    sgRank: string;
    userId: number;
}

export interface PersonalScorecardList {
    items: PersonalScorecardListItem[];
}

class PersonalScorecardListItemModelTransformer
    implements
        ModelTransformer<
            PersonalScorecardListItem,
            ExtPersonalScorecardListItem
        >
{
    transform(model: ExtPersonalScorecardListItem): PersonalScorecardListItem {
        return {
            id: model.scoreCardId,
            name: model.scoreCardName,
            startDate: Util.dateToDate(model.startDate),
            endDate: Util.dateToDate(model.endDate),
            score: parseFloat(model.score),
            sgRank: model.sgRank,
            userId: model.userId,
        };
    }
}

class PersonalScorecardListItemModelSetTransformer extends ModelSetTransformer<
    PersonalScorecardListItem,
    ExtPersonalScorecardListItem
> {
    protected newTransformer(): ModelTransformer<
        PersonalScorecardListItem,
        ExtPersonalScorecardListItem
    > {
        return new PersonalScorecardListItemModelTransformer();
    }
}

export class PersonalScorecardListModelTransformer
    implements
        ModelTransformer<PersonalScorecardList, ExtPersonalScorecardListItem[]>
{
    transform(model: ExtPersonalScorecardListItem[]): PersonalScorecardList {
        const items =
            new PersonalScorecardListItemModelSetTransformer().transform(model);
        return {
            items,
        };
    }
}

export function validatePersonalScorecardList(
    model: PersonalScorecardList,
): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null && model.items != null && model.items.length !== 0;
    if (!valid) {
        throw new Error('PersonalScorecardList not valid');
    }
}
